import { Divider } from '@design-system';
import { isInNextSixDays } from '@utils/product';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { DrawByProductId } from '../../../../features/draws/types';
import {
  getProductRef,
  getProductStatus,
} from '../../../../helpers/purchasing';
import {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../../../../types/Purchasing';
import ProductDate from '../../ProductDate';
import { SignUpButton } from '../SignUpButton';
import { toClientUTCDateFormat } from '../utils';
import { PreOrderHeader } from './PreOrderHeader';

interface Props<T extends ProductPurchaseDetails> {
  draw: DrawByProductId;
  product: ProductType;
  purchasingController: ProductPurchasingController<T>;
}

export const PublicReleaseFlow: FC<Props<ProductPurchaseDetails>> = ({
  draw,
  product,
  purchasingController,
}) => {
  const { t } = useTranslation('product');

  const launchDate = new Date(toClientUTCDateFormat(product.launchDate));

  return (
    <>
      <PreOrderHeader active={false} title={t('preOrder.isClosed.title')} />
      <Divider className="my-6" variant="dashed" />
      <p className="text-center font-bold">
        {isInNextSixDays(launchDate)
          ? t('subscriptionDate.default.countdown')
          : t('subscriptionDate.default.date')}
      </p>
      <p className="mb-3 text-center">
        <ProductDate date={launchDate} />
      </p>
      <p className="mb-6 text-center text-sm text-neutral-4">
        {t('preOrder.isClosed.description', { count: draw.allocation })}
      </p>
      <SignUpButton
        labels={{ normal: t('notifyMe'), success: t('subscribed') }}
        product={product}
        productRef={getProductRef(purchasingController)}
        productStatus={getProductStatus(product, purchasingController)}
        showIcon
      />
    </>
  );
};
